import type { AddShopMemberDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

type UseInviteTeamMemberParams = {
	onSuccess?: () => void;
	onError?: () => void;
};

export default function useInviteTeamMember(
	shopId: string,
	options?: UseInviteTeamMemberParams,
) {
	const invalidateShop = useInvalidateShop(shopId);

	return useApiMutation(
		"post",
		"/shops/{shopId}/members/{email}",
		{
			invalidate: invalidateShop,
			onSuccess: () => {
				options?.onSuccess?.();
			},
			onError: () => {
				options?.onError?.();
			},
			mapVariables: ({
				email,
				roleId,
				storeId,
				warehouseId,
			}: {
				email: string;
				roleId: AddShopMemberDto["roleId"];
				storeId?: string;
				warehouseId?: string;
			}) => ({
				params: { path: { shopId, email } },
				body: {
					roleId,
					storeId,
					warehouseId,
				},
			}),
		},
	);
}
